export default __webpack_public_path__ + "static/media/flow.f1cb56ed.png";